import { Injectable, OnInit } from '@angular/core';
import { Router, CanActivate, ActivatedRoute, CanLoad, Route, UrlSegment } from '@angular/router';
import { AuthService } from './auth.service';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { GlobalService } from './global.service';

declare var swal: any;

@Injectable()
export class AuthGuardService implements CanLoad, CanActivate, OnInit {

    constructor(
        public global: GlobalService,
        public auth: AuthService,
        public router: Router,
        public route: ActivatedRoute
    ) {

    }

    ngOnInit(): void {
        console.log('iniciei');
    }

    canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {

        console.log('CanLoad:', route.path);
        console.log('CanLoad QueryString:', this.global.params);
        console.log('CanLoad LoggedUser:', this.global.loggedUser());

        if (this.global.loggedUser()) {
            if (['active-directory', 'login', 'recovery'].indexOf(route.path) >= 0) {
                this.router.navigate(['/home']);
                return false;
            }
            return true;
        } 
        else {
            if (this.global.params) {
                const brand = this.global.params.brand;
                if (this.global.params.token) {
                    return new Promise((resolve) => {
                        this.auth.tokenLogin(this.global.params.token, brand).then(
                            (response) => {
                                if (response) {
                                    if (['active-directory', 'login', 'recovery'].indexOf(route.path) >= 0) {
                                        this.router.navigate(['/home']);
                                    }
                                }
                                resolve(true);
                            },
                            (error) => {
                                console.log('CanLoad', error, route.path);
                                this.global.params = null;
                                swal({
                                    title: 'Login via Token',
                                    text: 'Erro ao efetuar o Logon, por favor tente novamente!',
                                    type: 'error'
                                }).then(() => {
                                    window.location.href = "https://portal.smartfit.com.br";
                                });
                                //this.router.navigate(['/active-directory']);
                                resolve(false);
                            }
                        );
                    });
                }
            } 
            else {
                // if (['active-directory', 'login', 'recovery'].indexOf(route.path) >= 0) {
                //     return true;
                // }
                // //this.router.navigate(['/active-directory']);
                window.location.href = "https://portal.smartfit.com.br";
                return false;
            }
        }
    }

    canActivate(): Observable<boolean> | boolean {
        const clientId = sessionStorage.getItem('client');

        const verify = this.auth.verifyClient(+clientId).map(res => {

            console.log('AuthGuard.CanActivate: Verify ', res);

            if (res.success) {
                if (['active-directory', 'login', 'recovery'].indexOf(this.router.url) >= 0) {
                    this.router.navigate(['/home']);
                }
                return true;
            } else {
                this.router.navigate(['/erros/403']);
            }
        }).first();

        return verify;
    }

    errorNotificate(msg: string): any {
        swal({
            title: 'Erro',
            text: msg,
            type: 'warning',
            confirmButtonClass: 'btn btn-success',
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts